import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { it } from 'vuetify/locale';
import defaults from './defaults';

//DragScroll
import {
    DARK_AQUA_THEME,
    DARK_BLUE_THEME,
    DARK_CYAN_THEME,
    DARK_GREEN_THEME,
    DARK_ORANGE_THEME,
    DARK_PURPLE_THEME
} from '@/theme/DarkTheme';
import { BLUE_THEME } from '@/theme/LightTheme';
import { VueDraggableNext } from 'vue-draggable-next';

export default createVuetify( {
    components: {
        ...components,
        draggable: VueDraggableNext,
    },
    directives,

    theme: {
        defaultTheme: 'BLUE_THEME',
        themes: {
            BLUE_THEME,
            DARK_BLUE_THEME,
            DARK_AQUA_THEME,
            DARK_ORANGE_THEME,
            DARK_PURPLE_THEME,
            DARK_GREEN_THEME,
            DARK_CYAN_THEME
        }
    },
    defaults,
    locale: {
        locale: 'it',
        messages: { it },
    },
    /*{
        VCard: {
            rounded: 'md'
        },
        VTextField: {
            variant: 'outlined',
            density: 'comfortable',
            color: 'primary'
        },
        VTextarea: {
            variant: 'outlined',
            density: 'comfortable',
            color: 'primary'
        },
        VSelect: {
            variant: 'outlined',
            density: 'comfortable',
            color: 'primary'
        },
        VListItem: {
            minHeight: '45px'
        },
        VTooltip: {
            location: 'top'
        }
    }*/
} );
